import React from 'react'
import './SearchCheckbox.scss'

const SearchCheckbox = ({
  value,
  setValue,
  label,
  isDisabled = false,
  forceStacked = false,
}) => {
  return (
    <div
      className={`SearchCheckbox ${isDisabled ? 'disabled' : ''} ${
        forceStacked ? 'force-stacked' : ''
      }`}
    >
      <label className="label-container">
        <input
          className="checkbox-input"
          type="checkbox"
          onChange={() => setValue(!value)}
          checked={value}
          disabled={isDisabled}
        />
        <div className="checkbox-box" />
        <div className="checkbox-label">{label}</div>
      </label>
    </div>
  )
}

export default SearchCheckbox
